type SignupPromoBenefit = {
  _uid: string;
  text: string;
};

type SignupPromoProps = {
  subline?: string;
  headline?: string;
  introHtml?: string;
  benefits?: SignupPromoBenefit[];
  outroHtml?: string;
};

const SignupPromo = ({
  subline,
  headline,
  introHtml,
  benefits,
  outroHtml,
}: SignupPromoProps) => (
  <div className="flex flex-col gap-10">
    <div className="flex flex-col">
      {subline && <p className="text-copy text-black">{subline}</p>}
      {headline && <h3 className="text-headline-xl text-black">{headline}</h3>}
    </div>

    <div className="flex flex-col gap-4">
      {introHtml && (
        <div
          className="text-copy text-black prose prose-p:text-black prose-a:text-black prose-a:underline max-w-none"
          dangerouslySetInnerHTML={{ __html: introHtml }}
        />
      )}

      {benefits && benefits.length > 0 && (
        <div className="flex flex-col gap-3">
          {benefits.map((benefit) => (
            <div key={benefit._uid} className="flex items-center gap-4">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-6 shrink-0 text-sky-100" aria-hidden="true">
                <circle cx="12" cy="12" r="12" fill="currentColor" />
                <path d="M7 12.5L10.5 16L17 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <p className="text-copy text-black">{benefit.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>

    {outroHtml && (
      <div
        className="text-copy text-black prose prose-p:text-black prose-a:text-black prose-a:underline max-w-none"
        dangerouslySetInnerHTML={{ __html: outroHtml }}
      />
    )}
  </div>
);

export { SignupPromo };
export type { SignupPromoProps };
